// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--Js3VQ","title":"dd31006766--title--TLQaR","text":"dd31006766--text--VCiL6"};